import { configs } from "../configs";

const { serverUrl } = configs;
const accountBaseUrl = `${serverUrl}/account`;

/**
 * 
 * @param {object} data { names, email, password, repeatPassword }
 * @returns promise
 */
export const handleCreateAccount = (data) => {
    return fetch(`${accountBaseUrl}/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data),
        mode: "cors"
    });
}

/**
 * 
 * @param {object} data { email, password }
 * @returns 
 */
export const handleAuthenticate = (data) => {
    return fetch(`${accountBaseUrl}/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data),
        mode: "cors"
    });
}


export const handleAuthorize = (token) => {
    return fetch(`${accountBaseUrl}/myaccount`, {
        method: "GET",
        headers: {
            'Authorization': `Bearer ${token}`
        },
        mode: 'cors'
    })
}

export const handleUpdate = (data, token) => {
    return fetch(`${accountBaseUrl}/update`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
        mode: "cors"
    })
}

export const userLogout = (token) => {
    return fetch(`${accountBaseUrl}/logout`, {
        method: "GET",
        headers: {
            'Authorization': `Bearer ${token}`
        },
        mode: 'cors'
    })
}

export const deleteUserAccount = (token) => {
    return fetch(`${accountBaseUrl}/delete`, {
        method: "DELETE",
        headers: {
            'Authorization': `Bearer ${token}`
        },
        mode: 'cors'
    })
}


//send reset email
export const sendResetMail = (email) => {
    return fetch(`${accountBaseUrl}/resetemail`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({ email }),
        mode: "cors"
    })
}

//reset password
export const recoverPassword = (data, resetToken) => {
    //console.log({ uri: `${accountBaseUrl}/recovery/${resetToken}` })
    return fetch(`${accountBaseUrl}/recovery/${resetToken}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data),
        mode: "cors"
    })
}


//change password
export const changePassword = (data, token) => {
    return fetch(`${accountBaseUrl}/changepassword`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
            "Accept": "application/json"
        },
        body: JSON.stringify(data),
        mode: "cors"
    })
}